import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "src/shared/shared.module";
import { EventSearchResolver } from "./event-search/event-search-resolver";
import { EventSearchMapPage } from "./event-search-map/event-search-map";
import { EventTester } from "./event-tester/event-tester";
import { IonicModule } from "@ionic/angular";
import { FormsModule } from "@angular/forms";
import { EventSearchPage } from "./event-search/event-search";
const routes: Routes = [
  // EventSearchModule
    { path: 'search', loadComponent: () =>
      import('./event-search/event-search').then(m => m.EventSearchPage)
    },
    { path: 'search-map', loadComponent: () =>
      import('./event-search-map/event-search-map').then(m => m.EventSearchMapPage)
    },
    { path: 'tester', loadComponent: () =>
      import('./event-tester/event-tester').then(m => m.EventTester)
    }
  ];
@NgModule({
    declarations: [
     EventSearchMapPage,
     EventTester,
     EventSearchPage
    ],
    imports: [
        HttpClientModule,
        SharedModule,
        CommonModule,
        TranslateModule,
        IonicModule,
        FormsModule,
        RouterModule.forChild(routes)
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
    ]
  })
  export class EventMainModule { }
  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }